import { useContext } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import AppContext from '../context/HeaderContext';

const Name = styled.span`
	font-weight: bold;
	font-style : italic;
`;

const Container = styled.div`
	padding    : 5px;
	height     : 30px;
	text-align : center;
	background : #FF8000;
	color      : #fff;

	a {
		cursor : pointer;
	}
`;

function LoginAsHeader({ original_user, user }) {
	const location             = useLocation();
	const { updateSwitchUser } = useContext(AppContext);

	function handleSwitch() {

		updateSwitchUser(null, null, false);
		window.location = location.pathname;
	}

	/* eslint-disable */
	return (
		<Container>
			<p>
				You're currently logged in as <Name>{user.first_name} {user.last_name}</Name>. Log back in as  <a hfef="#log-back-in" onClick={handleSwitch}>{original_user.first_name} {original_user.last_name}</a>
			</p>
		</Container>
	);
	/* eslint-enable */
}

export default LoginAsHeader;
